import type { DefaultOptionType } from 'antd/es/select';
import type { ShipmentCategoryResponse } from './api';

export const normalizeShipmentCategory = (list: ShipmentCategoryResponse): DefaultOptionType[] => {
  if (!list) {
    return [];
  }
  return list.map((item) => ({
    label: item.text,
    value: Number(item.value),
  }));
};
